
import tableLoading from "@/components/tableLoading";
import RentalCard from "@/components/RentalCardV2";
import RentalHeader from "@/components/core/RentalHeader";
import NoContent from "@/components/customer-content/NoContent";
import CheckoutModal from "@/components/modals/CheckoutModal";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueTimepicker from "vue2-timepicker";
import RangeSlider from "vue-range-slider";
// you probably need to import built-in style
import "vue-range-slider/dist/vue-range-slider.css";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  // layout: 'details-page',
  scrollToTop: true,
  components: {
    RentalHeader,
    RentalCard,
    NoContent,
    tableLoading,
    CheckoutModal,
    DatePicker,
    VueTimepicker,
    RangeSlider,
    DateRangePicker,
  },

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content:
            "car hire in goa, car hire in goa airport, car hire in goa with driver, self drive car hire in goa, car hire in goa without driver, best car hire in goa, luxury car hire in goa, car hire in goa price, car hire in goa self drive, cheapest car hire in goa, car hire in goa near baga beach, car hire in panjim goa",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content: this.title,
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: this.description,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.title ? this.title : "Car Hire in Goa",
        },
        {
          hid: "og:image",
          property: "og:image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/rentals-meta-image.webp",
        },
        {
          hid: "image",
          property: "image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/rentals-meta-image.webp",
        },
        {
          hid: "twitter-image",
          property: "twitter:image",
          content:
            this.$config.siteUrl + "/img/meta-imgs/rentals-meta-image.webp",
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href: "https://cdn.jsdelivr.net/npm/vue2-timepicker@1.1.5/dist/VueTimepicker.css",
        },
      ],
      script: [
        {
          src: "https://cdn.jsdelivr.net/npm/vue2-timepicker@1.1.5/dist/VueTimepicker.umd.min.js",
        },
      ],
    };
  },
  data() {
    return {
      title: "Car Hire in Goa | Affordable & Reliable Car Rentals | Goa App",
      description:
        "car hire in goa, car hire in goa airport, car hire in goa with driver, self drive car hire in goa, car hire in goa without driver, best car hire in goa, luxury car hire in goa, car hire in goa price, car hire in goa self drive, cheapest car hire in goa, car hire in goa near baga beach, car hire in panjim goa",
      selected: null,
      options: [
        {
          value: null,
          text: "Please select an option",
        },
        {
          value: "a",
          text: "This is First option",
        },
        {
          value: "b",
          text: "Selected Option",
        },
        {
          value: {
            C: "3PO",
          },
          text: "This is an option with object value",
        },
        {
          value: "d",
          text: "This one is disabled",
          disabled: true,
        },
      ],
      cities: [],
      popularCities: null,
      categories: null,
      amenities: null,
      filters: {
        categories: [],
        allCategory: true,
        amenities: [],
        allAmenity: true,
        sortBy: "popular",
      },
      selectedVehicleCity: 0,
      selectedVehicle: null,
      selectedVehicleCityData: {
        name: null,
        id: null,
      },
      form: {
        dropDate: null,
        pickUpDate: null,
        pickUpTime: {
          HH: "09",
          mm: "00",
        },
        dropTime: {
          hh: "09",
          mm: "00",
          a: "am",
        },
        newPickUpTime: "09:00 am",
      },
      searchObject: null,
      selectedValue: null,
      search: null,
      dropValue: null,
      isSearchClicked: false,
      applyFilterClicked: false,
      listings: {},
      loading: true,
      listingLoading: false,
      addToCartLoading: false,
      bookNowLoading: false,
      vehicleDetails: null,
      selectedDeal: -1,
      selectedDealData: null,
      displayTime: null,

      //new UI vars
      sectionId: 0,
      mobilePickUp: 35,

      mobilePickUpDate: null,
      mobileDropOffDate: null,
      citysearch: "",
      isLocSame: false,
      timePickerList: [
        "00:15 am",
        "00:30 am",
        "00:45 am",
        "01:00 am",
        "01:15 am",
        "01:30 am",
        "01:45 am",
        "02:00 am",
        "02:15 am",
        "02:30 am",
        "02:45 am",
        "03:00 am",
        "03:15 am",
        "03:30 am",
        "03:45 am",
        "04:00 am",
        "04:15 am",
        "04:30 am",
        "04:45 am",
        "05:00 am",
        "05:15 am",
        "05:30 am",
        "05:45 am",
        "06:00 am",
        "06:15 am",
        "06:30 am",
        "06:45 am",
        "07:00 am",
        "07:15 am",
        "07:30 am",
        "07:45 am",
        "08:00 am",
        "08:15 am",
        "08:30 am",
        "08:45 am",
        "09:00 am",
        "09:15 am",
        "09:30 am",
        "09:45 am",
        "10:00 am",
        "10:15 am",
        "10:30 am",
        "10:45 am",
        "11:00 am",
        "11:15 am",
        "11:30 am",
        "11:45 am",
        "12:00 pm",
        "12:15 pm",
        "12:30 pm",
        "12:45 pm",
        "01:00 pm",
        "01:15 pm",
        "01:30 pm",
        "01:45 pm",
        "02:00 pm",
        "02:15 pm",
        "02:30 pm",
        "02:45 pm",
        "03:00 pm",
        "03:15 pm",
        "03:30 pm",
        "03:45 pm",
        "04:00 pm",
        "04:15 pm",
        "04:30 pm",
        "04:45 pm",
        "05:00 pm",
        "05:15 pm",
        "05:30 pm",
        "05:45 pm",
        "06:00 pm",
        "06:15 pm",
        "06:30 pm",
        "06:45 pm",
        "07:00 pm",
        "07:15 pm",
        "07:30 pm",
        "07:45 pm",
        "08:00 pm",
        "08:15 pm",
        "08:30 pm",
        "08:45 pm",
        "09:00 pm",
        "09:15 pm",
        "09:30 pm",
        "09:45 pm",
        "10:00 pm",
        "10:15 pm",
        "10:30 pm",
        "10:45 pm",
        "11:00 pm",
        "11:15 pm",
        "11:30 pm",
        "11:45 pm",
      ],
      mobtimePickerList: [
        "00:00 am",
        "00:30 am",
        "01:00 am",
        "01:30 am",
        "02:00 am",
        "02:30 am",
        "03:00 am",
        "03:30 am",
        "04:00 am",
        "04:30 am",
        "05:00 am",
        "05:30 am",
        "06:00 am",
        "06:30 am",
        "07:00 am",
        "07:30 am",
        "08:00 am",
        "08:30 am",
        "09:00 am",
        "09:30 am",
        "10:00 am",
        "10:30 am",
        "11:00 am",
        "11:30 am",
        "12:00 pm",
        "12:30 pm",
        "01:00 pm",
        "01:30 pm",
        "02:00 pm",
        "02:30 pm",
        "03:00 pm",
        "03:30 pm",
        "04:00 pm",
        "04:30 pm",
        "05:00 pm",
        "05:30 pm",
        "06:00 pm",
        "06:30 pm",
        "07:00 pm",
        "07:30 pm",
        "08:00 pm",
        "08:30 pm",
        "09:00 pm",
        "09:30 pm",
        "10:00 pm",
        "10:30 pm",
        "11:00 pm",
        "11:30 pm",
      ],
      sec1visible: true,

      dateRangeEx: {
        startDate: null,
        endDate: null,
      },
      dateRangeEndEx: {
        startDate: null,
        endDate: null,
      },
      onHoverDate: null,
      onHoverFinishDate: null,
      mobileDateTimeValue: null,
      popUpPickUpTime: "09:00 am",
      searchBtnClickedWithErr: false,
    };
  },
  fetchOnServer: false,
  async fetch() {
    //Get the list of page data
    this.categories = await fetch(
      this.$config.fetchUrl + "/api/vehicleCategories"
    ).then((res) => res.text());
    this.categories = this.getCryptKey(this.categories);
    this.amenities = await fetch(
      this.$config.fetchUrl + "/api/vehicleAmenities"
    ).then((res) => res.text());
    this.amenities = this.getCryptKey(this.amenities);
    this.popularCities = await fetch(
      this.$config.fetchUrl + "/api/rentals/v2/getPopularCities"
    )
      .then((res) => res.text())
      .catch((error) => {
        console.error("There was an error!", error);
        return false;
        return [];
      });
    this.popularCities = this.getCryptKey(this.popularCities);
    // Get list of cities
    this.cities = await fetch(
      this.$config.fetchUrl + "/api/rentals/v2/getAllCities"
    ).then((res) => res.text());
    this.cities = this.getCryptKey(this.cities);
    this.$nextTick(() => {
      if (this.popularCities && this.popularCities.length > 0) {
        //this.restoreFilter();
      }
    });
  },
  computed: {
    // Used for search function on the page
    filteredCityList() {
      if (this.popularCities) {
        return this.popularCities.filter((city) => {
          return city.name
            .toLowerCase()
            .includes(this.citysearch.toLowerCase().trim());
        });
      } else {
        return [];
      }
    },
  },
  destroyed() {
    if (document && document.getElementsByClassName("modalOverflow"))
      document.body.classList.remove("modalOverflow");
    if (document && document.getElementById("filterClose"))
      document.getElementById("filterClose").click();
  },
  mounted() {
    let searchedCategory = this.$route.query.category
      ? this.$route.query.category
      : null;
    var self = this;
    if (searchedCategory) {
      if (Array.isArray(searchedCategory)) {
        searchedCategory.forEach(function (value, index) {
          self.filters.categories.push(value);
        });
      } else {
        this.filters.categories.push(searchedCategory);
      }
      this.filters.allCategory = false;
    }
    if (this.popularCities && this.popularCities.length > 0) {
      // this.restoreFilter();
    }
    this.timeSlotOnChange();
    this.setInitialPickUpToday();
    this.setInputTime("09:00 am");
  },
  methods: {
    getCityName(val) {
      if (val) {
        const filteredCity = this.popularCities.filter((x) => x._id == val);
        return filteredCity && filteredCity.length > 0
          ? filteredCity[0].name
          : null;
      }
      return null;
    },

    mobilePickUpApplied() {
      this.form.pickUpDate = this.mobilePickUpDate;
      this.form.newPickUpTime = this.timePickerList[this.mobilePickUp];
      this.checkDates();
    },

    onPickUpModalOpen(modalType) {
      if (modalType == "pickup") {
        this.mobilePickUpDate = this.form.pickUpDate
          ? this.form.pickUpDate
          : null;
        this.mobilePickUp = this.form.newPickUpTime
          ? this.timePickerList.indexOf(this.form.newPickUpTime)
          : 35;

        this.popUpPickUpTime = moment(this.dateRangeEx.startDate).format(
          "h:mm a"
        );
      }
      if (modalType == "dropoff") {
        this.mobileDropOffDate = this.form.dropDate ? this.form.dropDate : null;
      }
    },

    checkPickDropLocSame() {
      if (!this.isLocSame && this.search) {
        this.dropValue = this.search;
      }
    },

    // Get the different between the pickup and drop date
    getDatePeriod(endDate, startDate) {
      var start = moment(startDate, "YYYY-MM-DD HH:mm:ss");
      var end = moment(endDate, "YYYY-MM-DD HH:mm:ss");
      start = new Date(start);
      end = new Date(end);
      //Difference in number of days

      // end = end.setHours(0, 1, 0)
      // end = new Date(end)

      // start = start.setHours(0, 0, 0)
      // start = new Date(start)
      start = moment(start, "YYYY-MM-DD HH:mm:ss");
      end = moment(end, "YYYY-MM-DD HH:mm:ss");
      var days = Math.ceil(end.diff(start, "hours") / 24);
      return days;
    },

    logEvent(e) {
      this.onHoverDate = e;
      let currentDate = new Date(e.startDate);
      if (
        !this.onHoverDate.startDate ||
        (this.onHoverDate.startDate &&
          moment(this.onHoverDate.startDate).format("YYYY/MM/DD") <=
            moment(currentDate).format("YYYY/MM/DD"))
      ) {
        currentDate.setDate(currentDate.getDate() + 2);
        let endDate = new Date(currentDate);
        endDate = endDate.setHours(9, 0, 0);
        endDate = new Date(endDate);
        this.onHoverFinishDate = endDate;
      }
    },
    logFinishEvent(e) {
      this.onHoverFinishDate = e.startDate;
      let endDate = new Date(e.startDate);
      endDate = endDate.setHours(9, 0, 0);
      endDate = new Date(endDate);
      this.onHoverFinishDate = endDate;
    },

    toggleDatePicker(e) {
      if (e == true) {
        this.onHoverDate = null;
        this.onHoverFinishDate = null;
      }
    },

    applyDatePicker(e) {
      let currentDate = new Date(e.startDate);
      let start = moment(currentDate, "YYYY-MM-DD");
      let end = moment(this.dateRangeEndEx.startDate, "YYYY-MM-DD");
      let daysDiff = this.dateRangeEndEx.startDate
        ? Math.floor(moment.duration(end.diff(start)).asDays())
        : 0;
      if (
        !this.dateRangeEndEx.startDate ||
        (this.dateRangeEndEx.startDate &&
          moment(this.dateRangeEndEx.startDate).format("YYYY/MM/DD") <=
            moment(currentDate).format("YYYY/MM/DD")) ||
        daysDiff == 1
      ) {
        currentDate.setDate(currentDate.getDate() + 2);
        let endDate = new Date(currentDate);
        endDate = endDate.setHours(9, 0, 0);
        endDate = new Date(endDate);
        this.dateRangeEndEx.startDate = this.dateRangeEndEx.endDate = endDate;
      }
    },

    applyEndDatePicker(e) {
      let endDate = new Date(e.startDate);
      endDate = endDate.setHours(9, 0, 0);
      endDate = new Date(endDate);
      this.dateRangeEndEx.startDate = this.dateRangeEndEx.endDate = endDate;
    },

    setInitialPickUpToday() {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + 2);
      var format = "hh:mm:ss";
      var time = moment(today, format);
      var beforeTime = moment("00:00:00", format);
      var afterTime = moment("17:00:00", format);
      if (time.isBetween(beforeTime, afterTime)) {
        this.form.pickUpDate = currentDate;
        this.dateRangeEx.startDate = currentDate;
        this.dateRangeEx.startDate = this.dateRangeEx.startDate.setHours(
          9,
          0,
          0
        );
        this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate);
      } else {
        this.form.pickUpDate = nextDate;
        this.dateRangeEx.startDate = nextDate;
        this.dateRangeEx.startDate = this.dateRangeEx.startDate.setHours(
          9,
          0,
          0
        );
        this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate);
      }
      this.checkDates();
    },

    openDropDownDateRange() {
      setTimeout(() => {
        this.$refs.picker.togglePicker(true);
      }, 100);
    },

    dateFormat(classes, date) {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var format = "hh:mm:ss";
      var time = moment(today, format);
      var beforeTime = moment("00:00:00", format);
      var afterTime = moment("17:00:00", format);
      var startDate = null;
      if (this.onHoverDate) {
        startDate = moment(this.onHoverDate, "DD-MM-YYYY").add(1, "days");
      }
      if (!classes.disabled) {
        if (time.isBetween(beforeTime, afterTime)) {
          classes.disabled =
            moment(date).format("YYYY/MM/DD") <=
              moment(today).format("YYYY/MM/DD") ||
            (this.onHoverDate
              ? moment(date).format("YYYY/MM/DD") <
                moment(this.onHoverDate).format("YYYY/MM/DD")
              : "") ||
            (startDate
              ? moment(date).format("YYYY/MM/DD") ==
                moment(startDate).format("YYYY/MM/DD")
              : "");
        } else {
          classes.disabled =
            moment(date).format("YYYY/MM/DD") <=
              moment(currentDate).format("YYYY/MM/DD") ||
            (this.onHoverDate
              ? moment(date).format("YYYY/MM/DD") <
                moment(this.onHoverDate).format("YYYY/MM/DD")
              : "") ||
            (startDate
              ? moment(date).format("YYYY/MM/DD") ==
                moment(startDate).format("YYYY/MM/DD")
              : "");
        }
      }
      return classes;
    },

    dateEndFormat(classes, date) {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var format = "hh:mm:ss";
      var time = moment(today, format);
      var beforeTime = moment("00:00:00", format);
      var afterTime = moment("17:00:00", format);
      var startDate = null;
      if (this.dateRangeEx.startDate) {
        startDate = moment(this.dateRangeEx.startDate, "DD-MM-YYYY").add(
          2,
          "days"
        );
        classes.activeStart =
          moment(this.dateRangeEx.startDate).format("YYYY/MM/DD") ==
          moment(date).format("YYYY/MM/DD");
      }
      if (!classes.disabled) {
        if (time.isBetween(beforeTime, afterTime)) {
          classes.disabled =
            moment(date).format("YYYY/MM/DD") <=
              moment(today).format("YYYY/MM/DD") ||
            (this.dateRangeEx.startDate
              ? moment(date).format("YYYY/MM/DD") <=
                moment(this.dateRangeEx.startDate).format("YYYY/MM/DD")
              : "") ||
            (startDate
              ? moment(date).format("YYYY/MM/DD") <
                moment(startDate).format("YYYY/MM/DD")
              : "");
        } else {
          classes.disabled =
            moment(date).format("YYYY/MM/DD") <=
              moment(currentDate).format("YYYY/MM/DD") ||
            (this.dateRangeEx.startDate
              ? moment(date).format("YYYY/MM/DD") <=
                moment(this.dateRangeEx.startDate).format("YYYY/MM/DD")
              : "") ||
            (startDate
              ? moment(date).format("YYYY/MM/DD") <
                moment(startDate).format("YYYY/MM/DD")
              : "");
        }
      }
      return classes;
    },

    setInputTime(value) {
      let val = moment(value, ["h:mm a"]).format("HH:mm");
      const [h, m] = val.split(":");
      const ms = new Date().setHours(h, m, 0);
      this.mobileDateTimeValue = new Date(ms);
    },

    mobilePickUpSearchClicked() {
      if (
        this.onHoverDate &&
        this.onHoverDate.startDate &&
        this.mobileDateTimeValue
      ) {
        let startDate = new Date(this.onHoverDate.startDate);
        //this.dateRangeEx.startDate = this.onHoverDate;
        //this.dateRangeEndEx.endDate = this.onHoverFinishDate;
        var hour = this.mobileDateTimeValue.getHours();
        var min = this.mobileDateTimeValue.getMinutes();
        startDate = startDate.setHours(
          hour || hour == 0 ? hour : 9,
          min ? min : 0,
          0
        );
        startDate = new Date(startDate);
        this.dateRangeEx.startDate = this.dateRangeEx.endDate = startDate;
        //this.dateRangeEx.startDate = new Date(this.dateRangeEx.startDate)
        this.applyDatePicker(this.dateRangeEx);
      } else if (this.mobileDateTimeValue && !this.onHoverDate) {
        var hour = this.mobileDateTimeValue.getHours();
        var min = this.mobileDateTimeValue.getMinutes();
        this.dateRangeEx.startDate = this.dateRangeEx.startDate.setHours(
          hour || hour == 0 ? hour : 9,
          min ? min : 0,
          0
        );
        this.dateRangeEx.startDate = this.dateRangeEx.endDate = new Date(
          this.dateRangeEx.startDate
        );
        this.applyDatePicker(this.dateRangeEx);
      }
    },

    mobileDropOffSearchClicked() {
      if (this.onHoverFinishDate) {
        let startDate = new Date(this.onHoverFinishDate);
        startDate = new Date(startDate);
        this.dateRangeEndEx.startDate = this.dateRangeEndEx.endDate = startDate;
        this.applyEndDatePicker(this.dateRangeEndEx);
      }
    },

    // new ui end

    goToAccordionSec(value) {
      if (value) window.scrollTo(0, 0);
      //this.scrollToJsRentals('section-2')
    },

    categoryAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
    },
    amenityAll() {
      this.filters.amenities = [];
      this.filters.allAmenity = true;
    },
    showClearBtn() {
      if (
        (!this.filters.allCategory && this.filters.categories.length > 0) ||
        (!this.filters.allAmenity && this.filters.amenities.length > 0)
      )
        return true;
      return false;
    },
    // Store filters in Localstorage
    storeFilters() {
      let filters = {
        categories: this.filters.categories,
        amenities: this.filters.amenities,
      };
      localStorage.setItem("rentalsFilter", JSON.stringify(filters));
    },

    restoreFilter() {
      if (process.browser) {
        if (localStorage.getItem("rentalId")) {
          let rentId = localStorage.getItem("rentalId");
          if (rentId && rentId.trim() != "") {
            this.selectedVehicleCityData.name =
              this.popularCities &&
              this.popularCities[rentId] &&
              this.popularCities[rentId].name
                ? this.popularCities[rentId].name
                : "";
            this.selectedVehicleCityData.id = rentId;
            this.search = rentId;
            this.dropValue = rentId;
            this.setSelected(rentId);
            //this.getListings(rentId);
            this.applyFilterClicked = true;
          }
          if (localStorage.getItem("rentalId")) {
            localStorage.removeItem("rentalId");
          }
        } else {
          if (this.popularCities && this.popularCities.length > 0) {
            this.selectedVehicleCityData.name = this.popularCities[0].name;
            this.selectedVehicleCityData.id = this.popularCities[0]._id;
            this.searchObject = this.popularCities[0];
            this.search = this.popularCities[0]._id;
            this.dropValue = this.popularCities[0]._id;
            //this.getListings(this.popularCities[0]._id, this.popularCities[0]._id, this.filters.amenities, this.filters.categories)
          } else {
            //this.getListings(0, 0, this.filters.amenities, this.filters.categories)
          }
        }
      }
    },

    setSelected(value) {
      this.searchObject = this.cities.find((x) => x._id === value);
    },

    getName(value) {
      return this.cities.find((x) => x._id === value);
    },
    clearAll() {
      this.filters.categories = [];
      this.filters.allCategory = true;
      this.filters.amenities = [];
      this.filters.allAmenity = true;
      this.$root.$emit("bv::toggle::collapse", "accordion-1");
      this.$root.$emit("bv::toggle::collapse", "accordion-2");
      if (this.popularCities && this.popularCities.length > 0) {
        this.selectedVehicleCityData.name = this.popularCities[0].name;
        this.selectedVehicleCityData.id = this.popularCities[0]._id;
        this.searchObject = this.popularCities[0];
        this.search = this.popularCities[0]._id;
        this.dropValue = this.popularCities[0]._id;
        //this.getListings(this.popularCities[0]._id, this.popularCities[0]._id)
      } else {
        //this.getListings(0)
      }
    },
    // TO get SUBSCRIPTIONS using pagination
    getListings(
      queryStr = null,
      dropStr = null,
      amenities = null,
      categories = null
    ) {
      this.searchBtnClickedWithErr = false;
      this.$refs.bookingForm.validate().then((success) => {
        if (!success) {
          // run your error code here
          // if (!this.isTimeValid()) {
          //   this.$refs.bookingForm.setErrors({
          //     timeSlot: ["This field is required"]
          //   });
          // }
          if (!queryStr) {
            this.$refs.bookingForm.setErrors({
              pickUpDesk: ["This field is required"],
            });
          }
          this.searchBtnClickedWithErr = true;
          this.formError = "One or more incorrect fields present, please fix.";
        } else {
          this.listingLoading = true;
          let cityid = 0;
          let dropid = 0;
          if (this.popularCities && this.popularCities.length > 0) {
            cityid = this.popularCities[0]._id;
            dropid = this.popularCities[0]._id;
          }
          if (queryStr) {
            cityid = queryStr;
          }
          if (dropStr) {
            dropid = dropStr;
          }
          var formData = new URLSearchParams();
          formData.append("city", queryStr ? queryStr : cityid);
          // if (categories != null && categories.length > 0) {
          //   categories.forEach(category => {
          //     formData.append('categories', category);
          //   })
          // }
          // if (amenities != null && amenities.length > 0) {
          //   amenities.forEach(amenity => {
          //     formData.append('amenities', amenity);
          //   })
          // }
          if (categories != null && categories.length > 0) {
            categories = encodeURIComponent(JSON.stringify(categories));
          } else {
            categories = ["all"];
          }
          if (amenities != null && amenities.length > 0) {
            amenities = encodeURIComponent(JSON.stringify(amenities));
          } else {
            amenities = ["all"];
          }

          // Add header for the API
          const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
          };
          // AXIOS api call to add review api
          this.$axios
            .get(
              `/api/rentals/v2/getVehiclesInCity/${cityid}/${dropid}/${categories}/${amenities}`,
              {
                headers: headers,
              }
            )
            .then((response) => {
              this.applyFilterClicked = false;
              this.sectionId = 1;
              this.sec1visible = true;
              // this.$root.$emit('bv::toggle::collapse', 'accordion-1');
              // this.$root.$emit('bv::toggle::collapse', 'accordion-2')
              this.scrollToJsRentals("section-2");
              if (queryStr) this.isSearchClicked = true;
              let value = this.getCryptKey(response.data);
              this.listings = value;
              this.selectedVehicle = this.listings[0];
              document.getElementById("filterClose").click();
              this.$nextTick(() => {
                //this.scrollToSectionIntoView('listing-card');
                this.listingLoading = false;
                this.applyFilterClicked = false;
              });
            })
            .catch((error) => {
              this.$nextTick(() => {
                this.listingLoading = false;
                this.applyFilterClicked = false;
              });
            })
            .finally(() => {
              this.$nextTick(() => {
                //this.scrollToSectionIntoView('listing-card');
                this.listingLoading = false;
                this.applyFilterClicked = false;
              });
            });
        }
      });
    },
    disabledBeforeToday(date) {
      const today = new Date();
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      var format = "hh:mm:ss";
      var time = moment(today, format);
      var beforeTime = moment("00:00:00", format);
      var afterTime = moment("17:00:00", format);
      if (time.isBetween(beforeTime, afterTime)) {
        return date <= today;
      } else {
        return date <= currentDate;
      }
    },
    disabledBeforePickUp(date) {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 2);
      if (this.form.pickUpDate) {
        var pickup = new Date(this.form.pickUpDate);
        pickup.setDate(pickup.getDate() + 2);
        return date < pickup;
      }
      return date <= currentDate;
    },
    checkDates() {
      var currentDate = null;
      if (this.form.pickUpDate) {
        currentDate = new Date(this.form.pickUpDate);
        currentDate.setDate(currentDate.getDate() + 2);
      }
      if (this.form.pickUpDate && this.form.dropDate) {
        this.form.dropDate =
          this.form.dropDate > this.form.pickUpDate
            ? this.form.dropDate
            : currentDate;
        this.dateRangeEndEx.startDate =
          this.dateRangeEndEx.startDate > this.dateRangeEx.startDate
            ? this.dateRangeEndEx.startDate
            : currentDate;
      } else if (this.form.pickUpDate && !this.form.dropDate) {
        this.form.dropDate = currentDate;
        this.dateRangeEndEx.startDate = currentDate;
      }
      this.dateRangeEx.endDate = this.dateRangeEx.startDate;
      this.dateRangeEndEx.endDate = this.dateRangeEndEx.startDate;
    },
    timeSlotOnChange() {
      if (this.isTimeValid()) {
        this.$refs.bookingForm.setErrors({
          timeSlot: [],
        });
      } else {
        this.$refs.bookingForm.setErrors({
          timeSlot: ["This field is required"],
        });
      }
    },
    isTimeValid() {
      if (
        this.form.pickUpTime == null ||
        this.form.pickUpTime.HH == "" ||
        this.form.pickUpTime.mm == "" ||
        this.form.pickUpTime.a == ""
      ) {
        return false;
      }
      let strng = this.form.pickUpTime.HH + "." + this.form.pickUpTime.mm;
      this.displayTime = moment(strng, ["HH:mm"]).format("hh:mm a");
      return true;
    },

    setGetDealsClicked(value) {
      if (value != null || value != undefined) {
        this.getDeals(value);
      }
    },

    getDeals(value) {
      if (value.id) {
        this.addToCartLoading = true;
        var pickUpDate = moment(this.dateRangeEx.startDate).format(
          "YYYY/MM/DD"
        );
        var dropDate = moment(this.dateRangeEndEx.endDate).format("YYYY/MM/DD");
        var convertedPickUpTime = moment(this.dateRangeEx.startDate).format(
          "HH:mm:ss"
        );
        var convertedDropTime = moment(
          this.form.dropTime.hh +
            ":" +
            this.form.dropTime.mm +
            " " +
            this.form.dropTime.a,
          "hh:mm A"
        ).format("HH:mm:ss");
        // Create formData instance to pass the data to the API
        let formData = {
          fromDate: pickUpDate,
          toDate: dropDate,
          fromTime: convertedPickUpTime,
          toTime: convertedDropTime,
          quantity: value.quantity,
          city: this.search ? this.search : null,
          drop: this.dropValue ? this.dropValue : null,
          vehicle: value.id,
        };
        // Add header for the API
        const headers = {
          "Content-Type": "application/json",
        };
        // AXIOS api call to add categories api
        this.$axios
          .post("/api/rentals/v2/getBestDeals", formData, {
            headers: headers,
          })
          .then((response) => {
            this.addToCartLoading = false;
            this.sectionId = 2;
            this.sec1visible = false;
            this.scrollToJsRentals("section-3");
            let value = this.getCryptKey(response.data);
            this.vehicleDetails = value;
            if (
              this.vehicleDetails &&
              this.vehicleDetails.deals &&
              this.vehicleDetails.deals.length > 0 &&
              this.vehicleDetails.deals[0].offer &&
              this.vehicleDetails.deals[0].offer.length > 0
            )
              this.vehicleDetails.deals[0].offer.sort(
                (a, b) => parseFloat(a.totalRent) - parseFloat(b.totalRent)
              );
            this.$root.$emit("bv::toggle::collapse", "accordion-2");
            //this.$root.$emit('bv::toggle::collapse', 'accordion-3')

            this.$nextTick(() => {});
          })
          .catch((error) => {
            this.addToCartLoading = false;
          })
          .finally(() => {
            this.addToCartLoading = false;
          });
      }
    },
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`);
    },

    goToCheckout() {
      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        if (this.selectedDealData && this.vehicleDetails) {
          this.bookNowLoading = true;
          // Create formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append(
            "fromDate",
            moment(this.vehicleDetails.fromDate).format("YYYY/MM/DD")
          );
          formData.append(
            "toDate",
            moment(this.vehicleDetails.toDate).format("YYYY/MM/DD")
          );
          formData.append("fromTime", this.vehicleDetails.fromTime);
          formData.append("toTime", this.vehicleDetails.toTime);
          formData.append("quantity", this.vehicleDetails.quantity);
          formData.append(
            "city",
            this.vehicleDetails.city && this.vehicleDetails.city._id
              ? this.vehicleDetails.city._id
              : null
          );
          formData.append(
            "drop",
            this.vehicleDetails.drop && this.vehicleDetails.drop._id
              ? this.vehicleDetails.drop._id
              : null
          );
          formData.append(
            "vehicle",
            this.vehicleDetails.vehicle && this.vehicleDetails.vehicle._id
              ? this.vehicleDetails.vehicle._id
              : null
          );
          formData.append("vehicleMerchantVehicle", this.selectedDealData._id);
          if (this.referral) {
            formData.append("agent", this.referral);
          }
          if (this.refProperty) {
            formData.append("property", this.refProperty);
          }
          // Add header for the API
          const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: this.token,
          };
          // AXIOS api call to add categories api
          this.$axios
            .post("/api/rentalCarts/app/addToRentalCart", formData, {
              headers: headers,
            })
            .then((response) => {
              this.bookNowLoading = false;
              this.$router.push({
                path: "/rental-checkout",
              });
            })
            .catch((error) => {
              this.bookNowLoading = false;
            })
            .finally(() => {
              this.bookNowLoading = false;
            });
        }
      } else {
        this.$bvModal.show("checkout");
      }
    },
    userCreated() {
      this.goToCheckout();
    },
  },
};
